angular.module('jv.Admin.Users.PostParams.Factory', [])
    .factory('postParamsFAC', [function () {
        var serializeArray = function(arr, name, result) {
            result = result || [];
            angular.forEach(arr, function(value) {
                result.push({name: name, value: value});
            });
            return result;
        };
        return {
            transformInvite: function(inviteDefArray) {
                var resultArr = [];
                if (angular.isArray(inviteDefArray)) {
                    angular.forEach(inviteDefArray, function(status) {
                        if (status.value !== 'INVITATION_READ' && status.value !== 'INVITATION_NOT_READ') {
                            resultArr.push(status);
                        }
                    });
                    if (resultArr.length > 1) {
                        resultArr.splice(1, 0, {
                            key: 10,
                            value: 'INVITATION_PENDING'
                        });
                    }
                }
                return resultArr;
            },
            serializeObject: function(obj) {
                var result = [];
                angular.forEach(obj, function(value, key) {
                    if (angular.isArray(value)) {
                        serializeArray(value, key, result);
                    } else {
                        result.push({name: key, value: value});
                    }
                });
                return result;
            },
            formatURL: function() {
                var str = arguments[0], i, pattern;
                if (arguments.length > 0) {
                    for (i = 1; i < arguments.length; i++) {
                        pattern = '{' + (i - 1) + '}';
                        while (str.indexOf(pattern) > 0) {
                            str = str.replace(pattern, arguments[i]);
                        }
                    }
                }
                return str;
            }
        };
    }]);